import type { CustomCellEditorProps } from '@ag-grid-community/react';
import { IconPickerDropdown } from '../../icon-picker/dropdown';
import type { IconPickerType } from '../../icon-picker/icons';

export interface TableIconPickerProps extends CustomCellEditorProps {
  value: IconPickerType | undefined;
}

export function TableIconPicker({
  value,
  stopEditing,
  onValueChange,
}: TableIconPickerProps) {
  return (
    <IconPickerDropdown
      value={value}
      onChange={onValueChange}
      onClose={() => stopEditing(false)}
    />
  );
}
